export { default as BookingDetail } from "./BookingDetail";

